import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/lapostebj.png'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white authentication-card" }
const _hoisted_3 = { class: "card-body letter-spacing" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-muted mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16" }
const _hoisted_6 = { class: "form-group mb-10 mb-sm-15 mb-md-17" }
const _hoisted_7 = { class: "form-group mb-10 mb-sm-15 mb-md-17" }
const _hoisted_8 = { class: "form-group mb-10 mb-sm-15 mb-md-17" }
const _hoisted_9 = { class: "form-group mb-10 mb-sm-15 mb-md-17" }
const _hoisted_10 = { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1 mb-15 mb-md-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-center mb-10" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "logo-icon",
              style: {"height":"100px"}
            })
          ], -1)),
          _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, " Créer votre compte ", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _cache[1] || (_cache[1] = _createTextVNode(" Avez-vous déjà un compte ? ", -1)),
              _createVNode(_component_router_link, {
                to: "/login",
                class: "fw-bold"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Se connecter maintenant ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_Form, {
            ref: "registerForm",
            onSubmit: _ctx.addRegister,
            "validation-schema": _ctx.registerSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom complet", -1)),
                _createVNode(_component_Field, {
                  name: "nomComplet",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le nom complet"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "nomComplet",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Numéro de téléphone ", -1)),
                _createVNode(_component_Field, {
                  name: "telephone",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le numéro de téléphone"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "telephone",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot de passe ", -1)),
                _createVNode(_component_Field, {
                  name: "password",
                  type: "password",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le mot de passe"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "password",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Confirmer le mot de passe ", -1)),
                _createVNode(_component_Field, {
                  name: "password_confirm",
                  type: "password",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Confirmer le mot de passe"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "password_confirm",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Field, {
                  type: "checkbox",
                  class: "form-check-input shadow-none",
                  name: "termes",
                  value: true,
                  id: "remember-me"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "termes",
                  class: "text-danger"
                }),
                _cache[6] || (_cache[6] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "remember-me"
                }, [
                  _createTextVNode(" j'accepte les "),
                  _createElementVNode("a", {
                    href: "#",
                    class: "text-decoration-none"
                  }, "Conditions générales")
                ], -1))
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("button", {
                class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                type: "submit"
              }, " Inscrivez vous maintenant ", -1))
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ]))
}